import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import BrandLogo from "@/components/Brand";
import { useQuestionnaire } from "@/context/QuestionnaireContext";

export default function Completato() {
  const { reset } = useQuestionnaire();

  useEffect(() => {
    // free the local draft so a new visit starts fresh
    const t = setTimeout(() => reset(), 1200);
    return () => clearTimeout(t);
  }, [reset]);

  return (
    <div className="min-h-[100dvh] fs-dark text-white flex flex-col">
      <header className="w-full">
        <div className="mx-auto max-w-lg px-6 h-16 flex items-center justify-center">
          <BrandLogo variant="light" className="h-7" />
        </div>
      </header>

      <main className="flex-1 mx-auto w-full max-w-lg px-6 flex flex-col items-center justify-center text-center pb-20">
        <motion.div
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="h-24 w-24 rounded-full border border-white/20 grid place-items-center"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.35, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="h-16 w-16 rounded-full bg-white grid place-items-center"
          >
            <Check className="h-8 w-8 text-black" strokeWidth={2.5} />
          </motion.div>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="mt-10 font-heading text-3xl sm:text-4xl font-700 tracking-tight"
          data-testid="completion-title"
        >
          Longevity Test{" "}<br />completato
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.62, duration: 0.5 }}
          className="mt-5 text-base text-white/70 leading-relaxed max-w-sm"
        >
          Grazie. Le tue risposte sono state registrate correttamente e saranno utilizzate
          durante il tuo Longevity Check.
        </motion.p>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.6 }}
          className="mt-10 fs-eyebrow text-white/50"
        >
          FORMAeSALUTE
        </motion.p>
      </main>
    </div>
  );
}
